// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { FaUser, FaPhone, FaEnvelope, FaCalendarAlt, FaPhoneAlt, FaEnvelopeOpen } from 'react-icons/fa';

// const Profile = () => {
//     const [userData, setUserData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');

//     const userId = sessionStorage.getItem('userId');

//     useEffect(() => {
//         const fetchUserData = async () => {
//             try {
//                 const response = await axios.get(`https://qrapi.emedha.in/users/${userId}`);
//                 setUserData(response.data);
//                 setLoading(false);
//             } catch (err) {
//                 setError('Failed to fetch user data');
//                 setLoading(false);
//             }
//         };

//         fetchUserData();
//     }, [userId]);

//     if (loading) {
//         return <div style={styles.loading}>Loading...</div>;
//     }

//     if (error) {
//         return <div style={styles.error}>{error}</div>;
//     }

//     return (
//         <div style={styles.profileContainer}>
//             <div style={styles.header}>
//                 <div style={styles.avatar}>
//                     <FaUser size={60} style={styles.icon} />
//                 </div>
//                 <h2 style={styles.userName}>{userData.name}</h2>
//             </div>
//             <div style={styles.detailsContainer}>
//                 <div style={styles.details}>
//                     <FaUser size={24} style={styles.icon1} />
//                     <span style={styles.detailText}>Name: {userData.name}</span>
//                 </div>
//                 <div style={styles.details}>
//                     <FaEnvelopeOpen size={24} style={styles.icon1} />
//                     <span style={styles.detailText}>Email: {userData.email}</span>
//                 </div>
//                 <div style={styles.details}>
//                     <FaPhoneAlt size={24} style={styles.icon1} />
//                     <span style={styles.detailText}>Mobile: {userData.mobile}</span>
//                 </div>
//                 <div style={styles.details}>
//                     <FaCalendarAlt size={24} style={styles.icon1} />
//                     <span style={styles.detailText}>Member Since: {new Date(userData.created_at).toLocaleDateString()}</span>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // Updated CSS styles with animations and enhanced visuals
// const styles = {
//     profileContainer: {
//         maxWidth: '600px',
//         margin: '50px auto',
//         padding: '30px',
//         border: '1px solid #e0e0e0',
//         borderRadius: '12px',
//         boxShadow: '0 12px 30px rgba(0, 0, 0, 0.1)',
//         background: '#f4f4f9',
//         textAlign: 'center',
//         fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//         animation: 'fadeIn 1s ease-in-out',
//     },
//     header: {
//         marginBottom: '30px',
//         borderBottom: '2px solid #e0e0e0',
//         paddingBottom: '20px',
//     },
//     avatar: {
//         backgroundColor: '#007bff',
//         color: 'white',
//         borderRadius: '50%',
//         padding: '25px',
//         marginBottom: '15px',
//         display: 'inline-block',
//     },
//     icon: {
//         color: 'white',
//         backgroundColor: '#007bff',
//         borderRadius: '50%',
//         padding: '12px',
//         transition: 'background-color 0.3s ease, transform 0.3s ease',
//     },

//     icon1: {
//         color: 'red',
//         backgroundColor: '#007bff',
//         borderRadius: '50%',
//         padding: '12px',
//         transition: 'background-color 0.3s ease, transform 0.3s ease',
//     },
//     userName: {
//         fontSize: '28px',
//         fontWeight: '600',
//         color: '#333',
//         marginBottom: '10px',
//     },
//     detailsContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '20px',
//         fontSize: '18px',
//         color: '#444',
//     },
//     details: {
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'flex-start',
//         padding: '10px',
//         borderBottom: '1px solid #e0e0e0',
//         transition: 'transform 0.3s ease',
//     },
//     detailText: {
//         marginLeft: '15px',
//         color: '#555',
//         fontWeight: '500',
//     },
//     loading: {
//         textAlign: 'center',
//         fontSize: '24px',
//         color: '#007bff',
//         marginTop: '50px',
//     },
//     error: {
//         textAlign: 'center',
//         fontSize: '18px',
//         color: 'red',
//         marginTop: '50px',
//     },
// };

// // Keyframe animations for profile elements
// const globalStyles = `
//     @keyframes fadeIn {
//         0% { opacity: 0; transform: translateY(20px); }
//         100% { opacity: 1; transform: translateY(0); }
//     }
//     @keyframes slideIn {
//         0% { opacity: 0; transform: translateY(20px); }
//         100% { opacity: 1; transform: translateY(0); }
//     }
//     .icon:hover {
//         background-color: #0056b3;
//         transform: scale(1.1);
//     }
// `;

// document.head.insertAdjacentHTML('beforeend', `<style>${globalStyles}</style>`);

// export default Profile;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaUser, FaPhoneAlt, FaEnvelopeOpen, FaCalendarAlt, FaEdit } from 'react-icons/fa';

const Profile = () => {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState({
        name: '',
        email: '',
        mobile: ''
    });

    const userId = sessionStorage.getItem('userId');

    useEffect(() => {
        fetchUserData();
    }, [userId]);

    const fetchUserData = async () => {
        try {
            const response = await axios.get(`https://qrapi.emedha.in/users/${userId}`);
            setUserData(response.data);
            setEditData({
                name: response.data.name,
                email: response.data.email,
                mobile: response.data.mobile
            });
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch user data');
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditData({ ...editData, [name]: value });
    };

    const handleUpdate = async () => {
        try {
            await axios.put(`https://qrapi.emedha.in/user/update/${userId}`, editData);
            setShowModal(false);
            fetchUserData();
        } catch (err) {
            alert('Failed to update user');
        }
    };

    if (loading) return <div style={styles.loading}>Loading...</div>;
    if (error) return <div style={styles.error}>{error}</div>;

    return (
        <div style={styles.profileContainer}>
            <div style={styles.header}>
                <div style={styles.avatar}>
                    <FaUser size={60} style={styles.icon} />
                </div>
                <h2 style={styles.userName}>{userData.name}</h2>
                <FaEdit
                    size={22}
                    style={styles.editIcon}
                    onClick={() => setShowModal(true)}
                    title="Edit Profile"
                />
            </div>

            <div style={styles.detailsContainer}>
                <div style={styles.details}>
                    <FaUser size={40} style={styles.icon1} />
                    <span style={styles.detailText}>Name: {userData.name}</span>
                </div>
                <div style={styles.details}>
                    <FaEnvelopeOpen size={40} style={styles.icon1} />
                    <span style={styles.detailText}>Email: {userData.email}</span>
                </div>
                <div style={styles.details}>
                    <FaPhoneAlt size={40} style={styles.icon1} />
                    <span style={styles.detailText}>Mobile: {userData.mobile}</span>
                </div>
                <div style={styles.details}>
                    <FaCalendarAlt size={40} style={styles.icon1} />
                    <span style={styles.detailText}>
                        Member Since: {new Date(userData.created_at).toLocaleDateString()}
                    </span>
                </div>
            </div>

            {/* Modal for Editing */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Profile</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={editData.name}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={editData.email}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Mobile</Form.Label>
                            <Form.Control
                                type="text"
                                name="mobile"
                                value={editData.mobile}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleUpdate}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

// Same styles as your original code
const styles = {
 profileContainer: {
  maxWidth: '100%',
  width: '600px',
  margin: '30px auto',
  padding: '15px',
  border: '1px solid #e0e0e0',
  borderRadius: '12px',
  boxShadow: '0 12px 30px rgba(0, 0, 0, 0.1)',
  background: '#f4f4f9',
  textAlign: 'center',
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
},

    header: {
        marginBottom: '30px',
        borderBottom: '2px solid #e0e0e0',
        paddingBottom: '20px',
    },
    editIcon: {

    top: 20,
    right: 20,
    cursor: 'pointer',
    color: '#007bff'
},

avatar: {
  backgroundColor: '#007bff',
  color: 'white',
  borderRadius: '50%',
  padding: '20px',
  marginBottom: '15px',
  display: 'inline-block',
  minWidth: '60px',
},

    icon: {
        color: 'white',
        backgroundColor: '#007bff',
        borderRadius: '50%',
        padding: '12px',
        transition: 'background-color 0.3s ease, transform 0.3s ease',
    },
    icon1: {
        color: 'white',
        backgroundColor: '#007bff',
        borderRadius: '50%',
        padding: '12px',
        transition: 'background-color 0.3s ease, transform 0.3s ease',
    },
    userName: {
        fontSize: '28px',
        fontWeight: '600',
        color: '#333',
        marginBottom: '10px',
    },
   detailsContainer: {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  fontSize: '16px',
  color: '#444',
},

details: {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  padding: '10px 5px',
  borderBottom: '1px solid #e0e0e0',
  textAlign: 'left',
},

    detailText: {
        marginLeft: '15px',
        color: '#555',
        fontWeight: '500',
    },
    loading: {
        textAlign: 'center',
        fontSize: '24px',
        color: '#007bff',
        marginTop: '50px',
    },
    error: {
        textAlign: 'center',
        fontSize: '18px',
        color: 'red',
        marginTop: '50px',
    },
};

// Insert global styles for animations
const globalStyles = `
    @keyframes fadeIn {
        0% { opacity: 0; transform: translateY(20px); }
        100% { opacity: 1; transform: translateY(0); }
    }
`;
document.head.insertAdjacentHTML('beforeend', `<style>${globalStyles}</style>`);

export default Profile;
